import { FlightsClassTypes } from 'constants/flight'
import type { CharterRewardLeg } from 'hooks/Flights/useCharterRewardAvailability'
import { CHARTER_CASH_CABINS } from 'lib/maldivesCharter/charterCabins'
import type { CabinDateJourneys } from '../hooks/charterRewardAvailabilityContext'

interface BuildMaldivesCharterRewardLegsArgs {
  journeysByCabinDate: Map<FlightsClassTypes, Map<string, CabinDateJourneys>>
  dateRangesByMonth: Record<string, Array<{ checkIn: string; oneWayBundle?: boolean }>>
  fareClass: FlightsClassTypes
  cashCabins?: ReadonlyArray<FlightsClassTypes>
}

interface MaldivesCharterRewardLegs {
  rewardLegs: Array<CharterRewardLeg>
  rewardLegsByDate: Record<string, Array<string>>
}

export function buildMaldivesCharterRewardLegs({
  journeysByCabinDate,
  dateRangesByMonth,
  fareClass,
  cashCabins = CHARTER_CASH_CABINS,
}: BuildMaldivesCharterRewardLegsArgs): MaldivesCharterRewardLegs {
  const rewardLegs: Array<CharterRewardLeg> = []
  const rewardLegsByDate: Record<string, Array<string>> = {}
  const seenJourneyKeys = new Set<string>()

  const pageCabin = cashCabins.includes(fareClass) ? fareClass : FlightsClassTypes.ECONOMY
  const pageCabinMap = journeysByCabinDate.get(pageCabin)

  Object.values(dateRangesByMonth).forEach((dateRanges) => {
    dateRanges.forEach(({ checkIn, oneWayBundle }) => {
      const pageEntry = pageCabinMap?.get(checkIn)
      const journeyKeys = [pageEntry?.departing?.journeyKey, pageEntry?.returning?.journeyKey].filter(
        (journeyKey): journeyKey is string => !!journeyKey,
      )
      if ((oneWayBundle && journeyKeys.length > 0) || (!oneWayBundle && journeyKeys.length === 2)) {
        rewardLegsByDate[checkIn] = journeyKeys
      }

      cashCabins.forEach((cabin) => {
        const entry = journeysByCabinDate.get(cabin)?.get(checkIn)
        for (const journey of [entry?.departing, entry?.returning]) {
          const key = journey?.journeyKey
          if (!key || seenJourneyKeys.has(key)) continue
          seenJourneyKeys.add(key)
          rewardLegs.push({ journeyKey: key, legTotal: journey.price.all.totalFare ?? 0 })
        }
      })
    })
  })

  return { rewardLegs, rewardLegsByDate }
}
